import { Component,OnInit,ViewChild, OnDestroy} from '@angular/core';  
import {AutopassService} from './service/autopass.service';
import { TestQueryBuilderFilterRule } from '../model/TestQueryBuilderFilterRule';
import { RuleAppliedDTO  } from '../model/RuleAppliedDTO';
import { FilterLine  } from '../model/FilterLine';
import { FilterDTO } from '../model/FilterDTO';
import { OptionDTO } from '../model/OptionDTO';
import { TabsComponent } from '../DynamicTab/tabs.component';
import {MessageBox} from '../../commoncomponent/MessageBox/MessageBox';
import { AttachDocumentModalComponent } from '../modal/attachDocument.component';
import * as XLSX from 'xlsx';
import { RuleAppliedPropertyDTO  } from '../model/RuleAppliedPropertyDTO';
import Utils from '../../helpers/Util';
import UtilRules from '../helper/UtilRules'
import { SummaryDTO } from '../model/SummaryDTO';
import { State } from '@progress/kendo-data-query';
import { GridDataResult,PageChangeEvent} from '@progress/kendo-angular-grid';  
import {UserSettings} from 'src/app/model/UserSettings';
import { UserService} from '../../commonservices/user.service';
import { FilterLineDTO  } from '../model/FilterLineDTO';
import { RuleTemplateDTO } from '../model/RuleTemplateDTO';
import { NotificationService } from '@progress/kendo-angular-notification';
import { TabsComponentAutopass } from '../DynamicTab/tabs.componentAutopass';
import { ShareService } from '@global/shared.service';
import { switchMap, distinctUntilChanged, debounceTime, mergeMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CookieService } from 'ngx-cookie';

import { headerStyle } from '../rule.interface'

@Component({
  selector: 'app-form-rule',
  styleUrls: ['../rule.scss','./autopass.component.scss'],
  templateUrl: 'autopass.component.html'
})

export class AutoPassComponent implements OnInit, OnDestroy {

  @ViewChild('autopassEdit', { static: false }) editAutopassFormTemplate;
  @ViewChild(TabsComponentAutopass, { static: false }) tabsComponent;

  allFilter:Array<FilterDTO>;
  query:FilterLineDTO;
  preview:FilterLine;
  jsonResult:string;

  public windowOpened = false;
  public windowOpenedManualTest = false;
  public windowOpenedSummary = false;

  public invoiceIds:any;
  public objQuery:TestQueryBuilderFilterRule;
  filter:FilterDTO = { "Id":0, "Context":"Autopass", "FilterName":null,"Priority":1, "ClientCode":"", "TabTitle":"","IsChecked":false};
  client: Array<OptionDTO>;
  clientCode:string = "";
  datagrid: Array<FilterDTO> =[];
  appliedRule: RuleAppliedDTO[];
  rowData = [];
  ruleManualTest :any;
  divId = 0;
  accessorialList:any;
  uomList:any;
  sidList:any;
  invoiceIdsList:any;
  invoiceClientFieldList:any
  fieldDropDown:any;
  fieldDropDownCopy:any;
  entityDropDown:any;
  previewSep:any = [];
  summaryDetailList:any;
  public state: State = { skip: 0, take: 5, sort:[] }

  public stateTestResult: State = { skip: 0, take: 5, sort:[] }

  public stateTemplate: State = { skip: 0, take: 5, sort:[] }
  datagridCopy: any;
  private unsubscribe$ = new Subject<void>();

  public columnSummary: Array<any> = [];

  rulePageSize: number;
  rulelistTestData: { data: any; total: any; };
  rowDataCopy: any;
  clientList:any;
  carrierList:any;
  clientCarrierList:any;
  invoiceList:any;
  invoiceIdList:any;
  shipmentList:any;
  uomsList:any;
  invchargesList:any;
  clientFieldsList:any;
  invsidList:any;

  public userSettings: UserSettings;
  public isCheckedAllSummaryDtl:boolean = false;
  public isThereSelected:boolean = false;
  public gridViewTemplate: GridDataResult;
  public gridViewFilterList: GridDataResult;
  
  public ruleTemplateList :Array<RuleTemplateDTO> = [];
  templateNameList:any;
  templateSkip:number = 0;
  templateSize:number = 5;
  templateFilter:string = "";

  dialogOpened:boolean = false;
  templateName:string;
  templateNameListData: any[];

  globalSettings: any;

  _tempColumnSummary: Array<any>;

  headerStyle: any =  headerStyle;
               
  constructor( private _autopassService: AutopassService,
              private _messageBox: MessageBox,
              private _sharedService: ShareService,
              private _userService: UserService, 
              private _cookieService: CookieService,
              private _notificationService: NotificationService, )  {  

            this._sharedService.clientCurrencyEmit$.pipe(
              takeUntil(this.unsubscribe$),
              distinctUntilChanged()).subscribe(data => {
                  this.globalSettings = data;
                  this.onChangeClient(data.client);
            });
  }

  
  ngOnInit(): void {
    this.clientFetch();

    this._autopassService
        .GetAutopassConditionColumns()
        .pipe(
          switchMap(data => {
            this._tempColumnSummary = data.map(x => {
              return {
                title: x.Title,
                group: x.Group,
                property: x.Property,
                field: x.Field,
                isHidden: x.IsHidden ? 'true' : 'false'
              }
            });
            return this._userService.getApplicationSettings()
          })
        ).subscribe(data => {
          this.userSettings = JSON.parse(data.UserSettings);

          this.userSettings.AutopassConditionColumns.forEach(displayCol => {
            console.log(displayCol)
            this._tempColumnSummary.forEach(colSum => {
              if(displayCol === colSum.field){
                colSum.isHidden = "false";
              }
            });
          });

          this.columnSummary = this._tempColumnSummary;
        });

    // this._userService.getApplicationSettings().subscribe(response =>
    // {
    //   this.userSettings = JSON.parse(response.UserSettings);
    //   console.log(this.userSettings)
    //   this.userSettings.RuleDisplayColumnSummary.forEach(displayCol => {
    //     this.columnSummary.forEach(colSum => {
    //       if(displayCol === colSum.field){
    //         colSum.isHidden = "false";
    //       }
    //     });
    //   });
    // })

    var defaultValues =  JSON.parse(this._cookieService.get("__defaultSettings"));
    this.onChangeClient(defaultValues.client)
  }  

  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  
  public summaryOnChange(field){
    if(field.isHidden == "true"){
      field.isHidden = "false";
    }else{
      field.isHidden = "true";
    }
  }
  dbClickSummary(event){
    let rowIndex;
    if (event.path) { 
      rowIndex = event.path[1].rowIndex;
    }
    var filterIds = this.summaryDetailList[rowIndex].filterIds;
    this._autopassService.GetFilterByFilterId(filterIds).subscribe((data:any) => 
    {
      this.datagrid = data;
      this.tabsComponent.selectTabByTitle('Filter List');
    });
  }
  public filterSummaryList(){
    this.columnSummary = Utils.DeepCopy(this.columnSummary);
    this.clientList = this.columnSummary.filter(x=>x.group == 'client');
    this.carrierList = this.columnSummary.filter(x=>x.group == 'carrier');
    this.clientCarrierList = this.columnSummary.filter(x=>x.group == 'clientCarrier');
    this.invoiceList = this.columnSummary.filter(x=>x.group == 'invoice');
    this.invoiceIdList = this.columnSummary.filter(x=>x.group == 'invoiceId');
    this.shipmentList = this.columnSummary.filter(x=>x.group == 'shipment');
    this.uomsList = this.columnSummary.filter(x=>x.group == 'uom');
    this.invchargesList = this.columnSummary.filter(x=>x.group == 'invcharges');
    this.clientFieldsList = this.columnSummary.filter(x=>x.group == 'clientFields');
    this.invsidList = this.columnSummary.filter(x=>x.group == 'invsid');
    this.windowOpenedSummary = true;
  }
  public DisplaySummaryCount(){
    var temp = this.columnSummary.filter(x=>x.isHidden == 'false').map(({field}) => field);
    let sumry = { clientCode:this.clientCode, fields:temp } as SummaryDTO;
    // console.log(sumry)
    // return;
    this._autopassService.DisplaySummaryCount(sumry).subscribe((data:any) => 
    {
       this.summaryDetailList = data;

      //  var count = this.columnSummary.filter(x=>x.field == 'count')
      //  count[0].isHidden = "false";
      //  var temp = this.columnSummary.filter(x=>x.isHidden == 'false').map(({field}) => field);
       this.userSettings.AutopassConditionColumns = temp;
       this._userService.UpdateApplicationSettings(this.userSettings).subscribe((data:any) => {
      }); 
    });
  }
  public closeSummaryCount(){
    this.windowOpenedSummary = false;
  }
  deleteFilter(){
    //filter and select the ids
    var ids = this.datagrid.filter(item => item.IsChecked === true).map(function(v){
      return v.Id;
    });

    var scope = this;
    this._autopassService.DeleteAutopassRules(ids).subscribe((data:any) => 
    {
      //0 default to first page
      this._autopassService.GetFilterByClient(0,this.state.take,this.clientCode).subscribe((data:any) => { 
        this.gridViewFilterList = {
          data: data.FilterList,
          total: data.TotalFilter
        }
          this.datagrid = data.FilterList;
          this.datagridCopy = data.FilterList;
          this._notificationService.show({
            content: 'Successfully deleted!',
            animation: { type: 'fade', 
            duration: 500 },
            type: { style: 'info', icon: true }
           });
      });
    });
  }
  viewGridlist(e){
    var ruleid = e.dataItem.RuleId;
    this._autopassService.GetFilterById(ruleid).subscribe((data:FilterDTO) =>{})
    this._autopassService.GetFilterLineByFilterId(ruleid).subscribe((data:any) => 
    {
      //this is for filter preview..
      this.preview = data;
    });
    this._autopassService.GetAppliedRulesByFilterId(ruleid).subscribe((data:Array<RuleAppliedDTO>) =>
    {
        this.appliedRule = data;
        this.previewSep = [];
        UtilRules.FormatRuleAppliedPropertiesToString(this.appliedRule);
        var resetCtr = 3;
        var divId = 0;
        this.previewSep.push(0);
        var scope = this;
        this.appliedRule.forEach(element => {
          element.RuleProperty.forEach(function(ruleAp,index){
            ruleAp.Store = JSON.parse(ruleAp.Store);
            if(index === resetCtr){
              resetCtr+=3;
              divId+=1; 
              scope.previewSep.push(divId);
            }
            if(index < resetCtr){
              ruleAp.divId = divId;
            }
          });
        });
    });
  }
  
  public onRefresh(){
    this.clientFetch();
    this.onChangeClient(this.clientCode);
    this.datagrid = [];
    this.appliedRule = [];
    this.rowData = [];
    this.preview = null;
    this.invoiceIds = null;

    this.tabsComponent.showFilterList();

  }
  public editFilters(e) {

    var c = e.data.ClientCode;
    this.clientCode = e.data.ClientCode;
    this.filter.ClientCode = e.data.ClientCode;

    this._autopassService.EditFilter(c).subscribe((data:Array<OptionDTO>) => 
      {
        if(e.data.Id !== 0){
          this._autopassService.GetFilterById(e.data.Id).subscribe((data:FilterDTO) => 
          {
            console.log(data)
            this.filter = data;
            this.filter.TabTitle = `${this.filter.Id} - ${this.filter.FilterName}`;
            
            this.tabsComponent.openTab(this.filter.TabTitle,this.editAutopassFormTemplate,this.filter,true);
          });
        }
      });
  }

  editFilter(e){

       var c = e.dataItem.ClientCode;
    this.clientCode = e.dataItem.ClientCode;
    this.filter.ClientCode = e.dataItem.ClientCode;

    this._autopassService.EditFilter(c).subscribe((data:Array<OptionDTO>) => 
      { 
        if(e.dataItem.Id !== 0){
        
          this._autopassService.GetFilterById(e.dataItem.Id).subscribe((data:FilterDTO) => 
          {
            this.filter = data;
            this.filter.TabTitle =  `${this.filter.Id} - ${this.filter.FilterName}`;
            console.log(this.filter);
            this.tabsComponent.openTab(
              this.filter.TabTitle,
              this.editAutopassFormTemplate,
              this.filter,
              true
            );
          });
        }
      });
  }

  public pageChange(event: PageChangeEvent): void {
    this.state.skip = event.skip;
    var page = ( this.state.skip / this.state.take);
    this._autopassService.GetFilterByClient( page ,this.state.take,this.clientCode).subscribe((data:any) => 
    { 
      this.gridViewFilterList = {
        data: data.FilterList,
        total: data.TotalFilter
      }
      this.datagrid = data.FilterList;
      this.datagridCopy = data.FilterList;
    });
  }
  
  public pageChangeTestResult(event: PageChangeEvent): void {
    this.stateTestResult.skip = event.skip;
    this.rulelistTestData = {
      data: this.rowDataCopy.slice(this.stateTestResult.skip , this.stateTestResult.skip + this.rulePageSize),
      total: this.rowDataCopy.length
    };
  }
  public addFilter() {
    this.filter = { "Id":0, "Context":"Autopass", "FilterName":null,"Priority":1,"ClientCode":this.clientCode, "TabTitle":this.clientCode,"IsChecked":false};
    this.tabsComponent.openTab(
      this.filter.TabTitle,
      this.editAutopassFormTemplate,
      this.filter,
      true
    );
  }
  public clientFetch(){
    this._autopassService.GetClientCode(0, 10).subscribe((data:any) => 
    { 
      this.client = data;
    });
  }

  public test(query){
    this.windowOpened = true;
  }
  public execute(){
    this.objQuery = {invoiceIds:"", queryBuilderFilter:null,clientCode:""} as TestQueryBuilderFilterRule;
    this.objQuery.clientCode = this.clientCode;
    this.objQuery.invoiceIds = this.invoiceIds;
    this.objQuery.queryBuilderFilter = null;
    this._autopassService.TestRules(this.objQuery).subscribe((data:any) => 
    {
        this.rowData = data;
        this.rowDataCopy = data;
    });
  }

 public onChangePage(templateNameListData: Array<any>) {
    this.templateNameListData = templateNameListData;//will be call on first load and pass the first 10 w/c is default of this.invs variable 
  }

  public manualTest(){
    var scope = this;
    this.templateName = "";
    this._autopassService.GetUnAppliedRules().subscribe((data:Array<RuleAppliedPropertyDTO>) =>{
      this.ruleManualTest = data;
      this.divId = 0;
      let ruleTemplate:RuleTemplateDTO = { Id:0, Name: "",Entity: "",Field: "",Value: "",RowNo: 1,ClientCode:this.clientCode};
      scope.ruleTemplateList = [];
      scope.ruleTemplateList.push(ruleTemplate);
      scope.entityDropDown = JSON.parse(Utils.DeepCopy(data[0].RuleProperty[0].Store));
      scope.fieldDropDown = JSON.parse(Utils.DeepCopy(data[0].RuleProperty[1].Store));
      scope.fieldDropDownCopy = JSON.parse(Utils.DeepCopy(data[0].RuleProperty[1].Store));
      this._autopassService.GetAllInvoiceIdsListDropDown(this.clientCode).subscribe((data:Array<any>) =>
      {
        this.invoiceIdsList = data;
        this._autopassService.GetClientField(this.clientCode).subscribe((data:Array<OptionDTO>) => 
        { 
          this.invoiceClientFieldList = data;
          this._autopassService.GetSID().subscribe((data:Array<OptionDTO>) => 
          { 
            this.sidList = data;
            this._autopassService.GetUOM().subscribe((data:Array<OptionDTO>) => 
            { 
              this.uomList= data;
              this._autopassService.GetAllAccessorial().subscribe((data:Array<any>) =>
              {
                this.accessorialList = data;
                this.windowOpenedManualTest = true;
              })
            });
          });
        });
      });
    });
    this._autopassService.GetTemplate(this.stateTemplate.skip,this.stateTemplate.take,"").subscribe((data:any) =>{
   
      this.templateNameList = data.RuleTemplate;
      this.gridViewTemplate = {
        data: data.RuleTemplate,
        total: data.Count
      };
    })
  }
  public addNewManualTest(){
    let rowNum = this.ruleTemplateList.length + 1;
    let ruleTemplate:RuleTemplateDTO= { Id:0, Name: "",Entity: "",Field: "",Value: "",RowNo: rowNum,ClientCode:this.clientCode};
    this.ruleTemplateList.push(ruleTemplate);
  }

  public onChange(ruleTemp){
    ruleTemp.Field = "";
    if(ruleTemp.Entity == "InvoiceIDs"){
      this.fieldDropDown =Utils.DeepCopy(this.invoiceIdsList);
    }else if(ruleTemp.Entity == "ClientFields"){
      this.fieldDropDown  =  Utils.DeepCopy(this.invoiceClientFieldList)
    }else if(ruleTemp.Entity == "Uoms"){
      this.fieldDropDown =   Utils.DeepCopy(this.uomList)
    }else if(ruleTemp.Entity == "InvoiceCharges"){
      this.fieldDropDown =  Utils.DeepCopy(this.accessorialList )
    }else if(ruleTemp.Entity == "ShipmentIds"){
      this.fieldDropDown  =  Utils.DeepCopy(this.sidList);
    }else{
      this.fieldDropDown  = Utils.DeepCopy(this.fieldDropDownCopy);
      this.fieldDropDown = this.fieldDropDown.filter(element => {
        return element.Group ==  ruleTemp.Entity;
      });
    }
  }

  templatePageChange(event){
    this.stateTemplate.skip = event.skip / 5 ;
    this._autopassService.GetTemplate(this.stateTemplate.skip,this.stateTemplate.take,"").subscribe((data:any) =>{
      this.templateNameList = data.RuleTemplate;
      this.gridViewTemplate = {
        data: data.RuleTemplate,
        total: data.Count
      };
    })
  }
  public executeManualTest(){
    var temp = Utils.DeepCopy(this.ruleTemplateList);
    this._autopassService.ManualTest(temp).subscribe((data:any) => 
    {
        this.rowData = data;
    });
  }
  public searchTemplate(){
    this._autopassService.GetTemplate(this.templateSkip,this.templateSize,this.templateFilter).subscribe((data:any) =>{
      this.templateNameList = data.RuleTemplate;
      this.gridViewTemplate = {
        data: data.RuleTemplate,
        total: data.Count
      };
    })
  }

  public dbClickTemplate(e){
    this._autopassService.GetTemplateByName(e.Name).subscribe((data:any) =>{
      this.ruleTemplateList  = data;
      this.templateName = data[0].Name;
  })
  }

  public saveTemplate(){
    if(this.templateName == ""){
      this.dialogOpened = true;
    }else{
      this.updateTemplate();
    }
  }

  public saveTemplateDialog(){
    this.ruleTemplateList.forEach(element => {
      element.Name = this.templateName;
    });
    this._autopassService.SaveTemplate(this.ruleTemplateList).subscribe((data:any) => 
    {
   
        this.templateNameList = data.RuleTemplate;
        this.gridViewTemplate = {
          data: data.RuleTemplate,
          total: data.Count
        };
        this._notificationService.show({
          content: 'Successfully saved!',
          animation: { type: 'fade', 
          duration: 500 },
          type: { style: 'info', icon: true }
         });
    });
  }

  public updateTemplate(){
    this.ruleTemplateList .forEach(element => {
      element.Name = this.templateName
    });

    this._autopassService.UpdateTemplate(this.ruleTemplateList).subscribe((data:any) => 
    {
    
        this.templateNameList = data.RuleTemplate;
        this.gridViewTemplate = {
          data: data.RuleTemplate,
          total: data.Count
        };
        this._notificationService.show({
          content: 'Successfully saved!',
          animation: { type: 'fade', 
          duration: 500 },
          type: { style: 'info', icon: true }
         });
    })
  }

  public deleteTemplate1(e){
    
    let tempName = e.Name;
    this.templateNameList.forEach(function(item, index, object) {
      if (item.Name === tempName) {
        object.splice(index, 1);
      }
    });

    this._autopassService.DeleteTemplate(tempName).subscribe((data:any) => 
    {
    
      this.gridViewTemplate = {
        data: this.templateNameList,
        total: this.templateNameList.length
      };
      this._notificationService.show({
        content: 'Successfully deleted!',
        animation: { type: 'fade', 
        duration: 500 },
        type: { style: 'info', icon: true }
       });
    })
  }

  public deleteTemplate($event){
    this.templateNameList.forEach(function(item, index, object) {
      if (item.Name === $event.dataItem.Name) {
        object.splice(index, 1);
      }
    });

    this._autopassService.DeleteTemplate($event.dataItem.Name).subscribe((data:any) => 
    {
    
      this.gridViewTemplate = {
        data: this.templateNameList,
        total: this.templateNameList.length
      };
      this._notificationService.show({
        content: 'Successfully deleted!',
        animation: { type: 'fade', 
        duration: 500 },
        type: { style: 'info', icon: true }
       });
    })
  }

  public closeDialog(component) {
    this[component + 'Opened'] = false;
  }

  public closeDiv(index){
    this.ruleTemplateList.splice(index, 1);
  }
  public close() {
    this.windowOpened = false;
  }
  public closeManualTest() {
    this.windowOpenedManualTest = false;
  }

  public onChangeClient(clientCode){
      this.clientCode = clientCode;
    
      this._autopassService.GetFilterByClient(0,this.state.take,this.clientCode).subscribe((data:any) => { 
          this.gridViewFilterList = {
            data: data.FilterList,
            total: data.TotalFilter
          }
         this.datagrid = data.FilterList;
         this.datagridCopy = data.FilterList;
      });
  }

  public upload(){
    var x = this.clientCode
    const modal: any = this._messageBox.openCustoModal(AttachDocumentModalComponent);
    modal.componentInstance.clCode =  x;
  }
  public async exportExcelData(){
    var ids = this.datagrid.map(function(item) {
      return item.Id;
    });
  
    this._autopassService.GetExportRuleListAutopass(ids).subscribe((data:any) =>
    {

      const fileName = 'Rules.xlsx';
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Rules');
      XLSX.writeFile(wb, fileName);
    });
  }
  public async exportExcelSummaryList(){
    const fileName = 'FilterFieldList.xlsx';
    var temp = this.columnSummary.filter(x=>x.isHidden == 'false').map(({property}) => property);
    var sumDetails = Utils.DeepCopy(this.summaryDetailList);
    if(this.isThereSelected){
      sumDetails = sumDetails.filter(x=>x.isSelected == true)
    }
    sumDetails.forEach(function(obj){
      for (var prop in obj) {
        if(!temp.includes(prop)){
          delete obj[prop];
        }
      }
    });
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(sumDetails);
    var columnHeader = this.columnSummary.filter(x=>x.isHidden == 'false').map(({title}) => title);
    var defaultColHeader = ["A1","B1","C1","D1","E1","F1","G1","H1","I1","J1","K1","L1","M1","N1","O1",
                          "P1","Q1","R1","S1","T1","U1","V1","W1","X1","Y1","Z1",
                          "AA1","AB1","AC1","AD1","AE1","AF1","AG1","AH1","AI1","AJ1","AK1","AL1","AM1","AN1","AO1","AP1","AQ1","AR1",
                          "AS1","AT1","AU1","AV1","AW1","AX1","AY1","AZ1",
                          "BA1","BB1","BC1","BD1","BE1","BF1","BG1","BH1","BI1","BJ1","BK1","BL1","BM1","BN1","BO1","BP1","BQ1","BR1",
                          "BS1","BT1","BU1","BV1","BW1","BX1","BY1","BZ1","CA1"];

    columnHeader.forEach(function(element,index){
      ws[defaultColHeader[index]].v = element;
    })

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Rules');
    XLSX.writeFile(wb, fileName);
  }

  onVisibilityChange(col){
    var displayCol = [];
    col.columns.forEach(element => {
      displayCol.push(element.field);
      this.columnSummary.forEach(prop => {
          if(element.field == prop.property){
            if(element.hidden){
              prop.isHidden = 'true';
            }else{
              prop.isHidden = 'false';
            }
          }
      });
    });
    var temp = this.columnSummary.filter(x=>x.isHidden == 'false').map(({field}) => field);
    this.userSettings.RuleDisplayColumnSummary = temp;
    this._userService.UpdateApplicationSettings(this.userSettings).subscribe((data:any) => {
    }); 
  }
  onRefreshFilterSummary(){
    console.log('refresh')
    this.clientFetch();
    this.datagrid = [];
    this.appliedRule = [];
    this.rowData = [];
    this.preview = null;
    this.invoiceIds = null;
    this.summaryDetailList = [];
    this.DisplaySummaryCount();
    // this.tabsComponent.closeAll();
  }
  public selectDisplayCount(idx){
    if(this.isThereSelected == false){
      this.isThereSelected = true;
    }else{
      this.isThereSelected = false;
    }
    if(this.summaryDetailList[idx].isSelected == false){
      this.summaryDetailList[idx].isSelected = true;
    }else{
      this.summaryDetailList[idx].isSelected = false;
    }
  }
  public onSelectAllChange(){
    if(this.isCheckedAllSummaryDtl == false){
      this.isCheckedAllSummaryDtl = true;
    }else{
      this.isCheckedAllSummaryDtl = false;
    }
    this.summaryDetailList.forEach(element => {
      if(element.isSelected == false){
        element.isSelected = true;
      }else{
        element.isSelected = false;
      }
    });
  }
}